export default __webpack_public_path__ + "static/media/white_cat.5a97a883.png";